/* eslint-disable no-shadow */
import React, { useState } from "react";
import {
  FlatList,
  View,
  TouchableWithoutFeedback,
  Image,
  TouchableOpacity,
  StyleSheet,
  Pressable,
} from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import CallIcon from "@assets/svg/CircleCall";
import DownArrow from "@assets/svg/DownArrow";
import Error from "@assets/svg/DbManagement/Error";
import { Menu, MenuItem } from "react-native-material-menu";
import { ScrollView } from "react-native-gesture-handler";

const ReconUserCard = ({
  item,
  callCustomer,
  onPressMissingQty = () => {},
  setCurrentExpandedIndex = () => {},
  expandedIndex,
  index,
}) => {
  const [dropdownState, setDropdownState] = useState(
    Array(item?.items?.length).fill(false),
  );

  const handleDropdownPress = (index) => {
    const updatedDropdownState = [...dropdownState];
    updatedDropdownState[index] = !updatedDropdownState[index];
    setDropdownState(updatedDropdownState);
  };

  const renderItems = ({ item, index }) => {
    return (
      <View>
        <View style={styles.itemContainer}>
          <View style={styles.imageContainer}>
            <Image
              source={{ uri: item?.product_image }}
              style={styles.image}
              resizeMode="cover"
            />
            <View style={styles.tagContainer}>
              <Text variant="caption_1" style={styles.tagText}>
                {item?.quantity}
              </Text>
            </View>
          </View>
          <View style={styles.itemDetails}>
            <Text variant="caption_2" style={styles.itemName}>
              {item?.short_name}
            </Text>
            <Text
              variant="caption_1"
              style={styles.itemPrice}
            >{`₹ ${item?.total}`}</Text>
            <View style={styles.quantityContainer}>
              <Text variant="body_text_3" style={styles.quantityText}>
                {`Qty: `}
                <Text variant="body_text_2" style={styles.quantityValue}>
                  {item?.quantity}
                </Text>
              </Text>
              {item?.missing_mark_drop_down?.length > 0 && (
                <Menu
                  visible={dropdownState[index]}
                  onRequestClose={() => handleDropdownPress(index)}
                  style={{
                    width: 50,
                    marginTop: 35,
                    marginLeft: item?.missing_qty === 0 ? 85 : 55,
                  }}
                  anchor={
                    <Pressable
                      testID="recon-missing-qty-btn"
                      style={styles.missingQtyContainer}
                      onPress={() => handleDropdownPress(index)}
                    >
                      {item?.missing_qty === 0 ? (
                        <Text variant="caption_2" style={styles.missingQtyText}>
                          Lost/Damage Qty.
                        </Text>
                      ) : (
                        <Text
                          variant="title_16"
                          style={[
                            styles.missingQtyText,
                            { color: color.black, lineHeight: 16 },
                          ]}
                        >
                          {item?.missing_qty}
                        </Text>
                      )}
                      <DownArrow />
                    </Pressable>
                  }
                >
                  <ScrollView
                    style={{ maxHeight: 200 }}
                    showsVerticalScrollIndicator={false}
                  >
                    {item?.missing_mark_drop_down?.map((i) => (
                      <MenuItem
                        onPress={() => {
                          onPressMissingQty(item, i);
                          handleDropdownPress(index);
                        }}
                        key={i}
                        style={{
                          paddingLeft: 5,
                          backgroundColor:
                            item?.missing_qty === i
                              ? "rgba(234, 244, 250, 1)"
                              : color.white,
                        }}
                      >
                        <Text
                          variant="body_text_2"
                          style={{
                            color:
                              item?.missing_qty === i
                                ? "rgba(42, 149, 209, 1)"
                                : color.black06,
                          }}
                        >
                          {i}
                        </Text>
                      </MenuItem>
                    ))}
                  </ScrollView>
                </Menu>
              )}
            </View>
          </View>
        </View>
        {item?.msg?.map((i) => (
          <View style={styles.msgContainer}>
            <Error />
            <Text
              variant="caption_2"
              style={{
                color:
                  i.type === "warning" ? color.plain_red : color.plain_green,
                marginLeft: 8,
                lineHeight: 18,
              }}
            >
              {i.txt}
            </Text>
          </View>
        ))}
        <View
          style={{
            height: 1,
            backgroundColor: color.lighterBlack,
            marginVertical: 6,
          }}
        />
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "flex-start",
          marginBottom: 6,
          flexWrap: "wrap",
        }}
      >
        {item?.bag_names?.map((i, index) => (
          <Text variant="heading_24" style={styles.bagNames} numberOfLines={1}>
            {index === item?.bag_names?.length - 1 ? i : `${i}, `}
          </Text>
        ))}
      </View>
      <View style={styles.userInfoContainer}>
        <View>
          <Text variant="title_16" style={styles.userName}>
            {item?.user_name}
          </Text>
          <Text
            variant="caption_2"
            style={styles.routeName}
          >{`Route: ${item?.route_name}`}</Text>
        </View>
        <TouchableWithoutFeedback
          onPress={() => callCustomer(item?.user_phone)}
        >
          <CallIcon />
        </TouchableWithoutFeedback>
      </View>
      <Text
        variant="body_text_2"
        style={styles.quantity}
      >{`Quantity: ${item?.total_qty}`}</Text>
      <FlatList
        data={expandedIndex === index ? item?.items : item?.items?.slice(0, 1)}
        keyExtractor={(i) => i.id}
        renderItem={renderItems}
      />
      {item?.items?.length > 1 && (
        <TouchableOpacity
          testID="recon-see-all-items"
          onPress={() => {
            if (expandedIndex === index) {
              setCurrentExpandedIndex(-1);
              return;
            }
            setCurrentExpandedIndex(index);
          }}
          style={styles.seeAllButton}
        >
          <Text variant="title_16" style={styles.seeAllText}>
            {expandedIndex === index ? "See less" : "See all item"}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default ReconUserCard;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    padding: 16,
    margin: 16,
    marginVertical: 8,
    borderRadius: 16,
    paddingBottom: 12,
  },
  bagNames: {
    fontSize: 24,
  },
  userInfoContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderColor: color.lighterBlack,
    borderWidth: 1,
    padding: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignItems: "center",
  },
  userName: {
    fontSize: 16,
    color: color.mediumBlack,
  },
  routeName: {
    fontSize: 12,
    color: color.black06,
    marginTop: 4,
  },
  quantity: {
    fontSize: 14,
    color: color.black,
    marginTop: 8,
    top: 2,
  },
  seeAllButton: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 12,
    width: "100%",
  },
  seeAllText: {
    fontSize: 16,
    color: color.mediumBlack,
  },
  itemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 12,
    paddingBottom: 6,
    alignItems: "center",
  },
  imageContainer: {
    height: 82,
    width: 82,
    borderRadius: 8,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    padding: 4,
  },
  image: {
    height: "100%",
    width: "100%",
  },
  itemDetails: {
    marginLeft: 12,
    flex: 1,
  },
  itemName: {
    fontSize: 12,
    color: color.mediumBlack,
  },
  itemPrice: {
    fontSize: 12,
    color: color.mediumBlacklightBlack,
    marginTop: 4,
  },
  quantityContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  quantityText: {
    fontSize: 12,
    color: color.black06,
    marginTop: 4,
  },
  quantityValue: {
    fontSize: 12,
    color: color.mediumBlack,
  },
  missingQtyContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    borderRadius: 6,
    backgroundColor: "rgba(242, 244, 251, 1)",
    minWidth: 80,
  },
  missingQtyText: {
    fontSize: 12,
    color: color.mediumBlacklightBlack,
    marginRight: 16,
  },
  tagContainer: {
    position: "absolute",
    top: -10,
    right: -6,
    backgroundColor: color.black,
    padding: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  tagText: {
    color: color.white,
    lineHeight: 16,
  },
  msgContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255, 77, 79, 0.05)",
    marginVertical: 4,
    padding: 5,
    borderRadius: 4,
    paddingLeft: 10,
  },
});
